/* eslint-disable indent */
import {
  AccountingIcon,
  AccountsTabIcon,
  BalanceTabIcon,
  BankingTabIcon,
  BusinessLoansTabIcon,
  CapitalIcon,
  CatalogTabIcon,
  CustomersTabIcon,
  DebitCardsTabIcon,
  DisputesTabIcon,
  EstimatesTabIcon,
  ExternalCompanyIcon,
  HomeTabIcon,
  IntegrationsTabIcon,
  InvoiceSettingsIcon,
  InvoicesTabIcon,
  JobsTabIcon,
  ManageTeamTabIcon,
  MapsTabIcon,
  MyAccountTabIcon,
  PayRunsTabIcon,
  PaymentsTabIcon,
  PayoutsTabIcon,
  ReceiptsTabIcon,
  ReportsTabIcon,
  ServiceChargeTabIcon,
  SettingsIcon,
  TaxesTabIcon,
  TeamProfileTabIcon
} from 'assets/icons';
import CategoriesTabReactIcon from 'assets/react-icons/CategoriesTabReactIcon';
import ItemsTabReactIcon from 'assets/react-icons/ItemsTabReactIcon';
import routesPath from 'routes/RoutesPath';
import { NavTab, clevertapEvents, navTabKeys } from 'types/baseTypes';

export const baseNavTabs: NavTab[] = [
  {
    id: 'home-nav',
    key: navTabKeys.home,
    title: 'Home',
    icon: HomeTabIcon,
    path: routesPath.HOME
  },
  {
    id: 'maps-nav',
    key: navTabKeys.maps,
    title: 'Map',
    icon: MapsTabIcon,
    path: routesPath.MAPS,
    clevertapEvent: clevertapEvents.WebMapsView
  },
  {
    id: 'jobs-nav',
    key: navTabKeys.jobs,
    title: 'Jobs',
    icon: JobsTabIcon,
    path: routesPath.JOBS,
    clevertapEvent: clevertapEvents.webJobsClick
  },
  {
    id: 'estimates-nav',
    key: navTabKeys.estimates,
    title: 'Estimates',
    icon: EstimatesTabIcon,
    path: routesPath.ESTIMATES,
    clevertapEvent: clevertapEvents.webEstimatesListView
  },
  {
    id: 'invoices-nav',
    key: navTabKeys.invoices,
    title: 'Invoices ',
    icon: InvoicesTabIcon,
    path: routesPath.INVOICES,
    clevertapEvent: clevertapEvents.webInvoicesListView
  },
  {
    id: 'payments-nav',
    key: navTabKeys.receiptsSection,
    title: 'Payments',
    icon: PaymentsTabIcon,
    path: routesPath.RECEIPTS,
    clevertapEvent: clevertapEvents.webReceiptsListView,
    hasChildTabs: true,
    childTabs: [
      {
        id: 'receipts-list-nav',
        key: navTabKeys.receipt,
        title: 'Receipts',
        icon: ReceiptsTabIcon,
        path: routesPath.RECEIPTS,
        clevertapEvent: clevertapEvents.webReceiptsListView
      },
      {
        id: 'disputes-nav',
        key: navTabKeys.disputes,
        title: 'Disputes',
        icon: DisputesTabIcon,
        path: routesPath.DISPUTES,
        clevertapEvent: clevertapEvents.webDisputesListView
      }
    ]
  },
  {
    id: 'payouts-nav',
    key: navTabKeys.payouts,
    title: 'Balances & Payouts',
    icon: PayoutsTabIcon,
    path: routesPath.PAYOUTS_BALANCE,
    clevertapEvent: clevertapEvents.webPayoutsBalanceView,
    hasChildTabs: true,
    childTabs: [
      {
        id: 'payouts-balance-nav',
        key: navTabKeys.payoutsBalance,
        title: 'Balance',
        icon: BalanceTabIcon,
        path: routesPath.PAYOUTS_BALANCE,
        clevertapEvent: clevertapEvents.webPayoutsBalanceView
      },
      {
        id: 'payouts-list-nav',
        key: navTabKeys.payoutsList,
        title: 'Payouts',
        icon: PayoutsTabIcon,
        path: routesPath.PAYOUTS_LIST,
        clevertapEvent: clevertapEvents.webPayoutsListView
      }
    ]
  },
  {
    id: 'customers-nav',
    key: navTabKeys.customers,
    title: 'Customers ',
    icon: CustomersTabIcon,
    path: routesPath.CUSTOMERS,
    clevertapEvent: clevertapEvents.webCustomersListView
  }
];

const accountingNavTabs: NavTab = {
  id: 'accounting-nav',
  key: navTabKeys.accounting,
  title: 'Accounting',
  icon: AccountingIcon,
  path: routesPath.ACCOUNTING_PAY_RUNS,
  hasChildTabs: true,
  clevertapEvent: clevertapEvents.WebPayRunsView,
  childTabs: [
    {
      id: 'pay-runs-nav',
      key: navTabKeys.payRuns,
      title: 'Pay runs',
      icon: PayRunsTabIcon,
      path: routesPath.ACCOUNTING_PAY_RUNS,
      clevertapEvent: clevertapEvents.WebPayRunsView
    },
    {
      id: 'external-company-nav',
      key: navTabKeys.externalCompany,
      title: 'External company',
      icon: ExternalCompanyIcon,
      path: routesPath.ACCOUNTING_EXTERNAL_COMPANY,
      clevertapEvent: clevertapEvents.WebExternalCompanyView
    }
  ]
};

const reportsNavTabs: NavTab = {
  id: 'reports-nav',
  key: navTabKeys.reports,
  title: 'Reports',
  icon: ReportsTabIcon,
  path: routesPath.REPORTS,
  hasChildTabs: false,
  clevertapEvent: clevertapEvents.WebReportsView
};

export const allPaymentNavTabs: NavTab[] = [
  accountingNavTabs,
  reportsNavTabs,
  {
    id: 'settings-nav',
    key: navTabKeys.settings,
    title: 'Settings',
    icon: SettingsIcon,
    path: routesPath.SETTINGS,
    clevertapEvent: clevertapEvents.WebSettingsMenu
  },
  {
    id: 'catalog-nav',
    key: navTabKeys.catalog,
    title: 'Catalog',
    icon: CatalogTabIcon,
    path: routesPath.CATALOG_ITEMS,
    clevertapEvent: clevertapEvents.webCatalogMenu,
    hasChildTabs: true,
    childTabs: [
      {
        id: 'catalog-items-nav',
        key: navTabKeys.catalogItems,
        title: 'Items',
        icon: ItemsTabReactIcon,
        path: routesPath.CATALOG_ITEMS,
        clevertapEvent: clevertapEvents.webCatalogItemsListView
      },
      {
        id: 'catalog-categories-nav',
        key: navTabKeys.catalogCategories,
        title: 'Categories',
        icon: CategoriesTabReactIcon,
        path: routesPath.CATALOG_CATEGORIES,
        clevertapEvent: clevertapEvents.webCatalogCategoryListView
      },
      {
        id: 'catalog-taxes-nav',
        key: navTabKeys.catalogTaxes,
        title: 'Taxes',
        icon: TaxesTabIcon,
        path: routesPath.CATALOG_TAXES,
        clevertapEvent: clevertapEvents.webCatalogTaxesListView
      },
      {
        id: 'catalog-service-charge-nav',
        key: navTabKeys.catalogServiceCharge,
        title: 'Service charges',
        icon: ServiceChargeTabIcon,
        path: routesPath.CATALOG_SERVICE_CHARGES,
        clevertapEvent: clevertapEvents.webCatalogServiceChargesListView
      }
    ]
  },
  {
    id: 'business-loans-nav',
    key: navTabKeys.businessLoans,
    title: 'Business Loans',
    icon: BusinessLoansTabIcon,
    path: routesPath.BUSINESS_LOANS,
    clevertapEvent: clevertapEvents.webBusinessLoansClick
  },
  {
    id: 'integrations-nav',
    key: navTabKeys.integrations,
    title: 'Add ons & Integrations',
    icon: IntegrationsTabIcon,
    path: routesPath.INTEGRATIONS,
    clevertapEvent: clevertapEvents.webIntegrationsView
  }
];

export const teamNavTabs: NavTab[] = [
  {
    id: 'team-profile-nav',
    key: navTabKeys.teamProfile,
    title: 'Team Profile',
    icon: TeamProfileTabIcon,
    path: routesPath.TEAM_PROFILE
  },
  {
    id: 'manage-team-nav',
    key: navTabKeys.manageTeam,
    title: 'Manage Team',
    icon: ManageTeamTabIcon,
    path: routesPath.MANAGE_TEAM,
    clevertapEvent: clevertapEvents.webManageTeamView
  }
];

export const bankingNavTabs: NavTab[] = [
  {
    id: 'banking-nav',
    key: navTabKeys.banking,
    title: 'Banking',
    icon: BankingTabIcon,
    path: routesPath.BANKING
  },
  {
    id: 'debit-cards-nav',
    key: navTabKeys.debitCards,
    title: 'Debit Cards',
    icon: DebitCardsTabIcon,
    path: routesPath.DEBIT_CARDS
  },
  {
    id: 'accounts-nav',
    key: navTabKeys.accounts,
    title: 'Accounts',
    icon: AccountsTabIcon,
    path: routesPath.ACCOUNTS
  }
];

export const accountSettingsNavTabs: NavTab[] = [
  {
    id: 'my-account-nav',
    key: navTabKeys.myAccount,
    title: 'My Account',
    icon: MyAccountTabIcon,
    path: routesPath.ACCOUNT_SETTINGS_MY_ACCOUNT
  }
  // TODO: Integrate Credits and Rewards once feature is made available in web
  // {
  //   id: 'credits-rewards-nav',
  //   key: navTabKeys.creditsRewards,
  //   title: 'Credits & Rewards',
  //   icon: CreditsRewardsTabIcon,
  //   path: routesPath.ACCOUNT_SETTINGS_CREDITS_REWARDS
  // }
];

const capitalNavTab = [
  {
    id: 'capital-nav',
    key: navTabKeys.capital,
    title: 'Financing',
    icon: CapitalIcon,
    path: routesPath.CAPITAL_FINANCING,
    clevertapEvent: null
  }
];

export const navTabs: NavTab[] = [
  ...baseNavTabs,
  ...capitalNavTab,
  ...allPaymentNavTabs,
  ...teamNavTabs,
  ...bankingNavTabs,
  ...accountSettingsNavTabs
];

const getPaymentsTab = ({
  showIntegrations,
  showBusinessLoans,
  showEstimateSettings,
  showAccountingTab,
  showReports
}) => {
  const paymentNavTabs: NavTab[] = [
    ...(showAccountingTab ? [accountingNavTabs] : []),
    ...(showReports ? [reportsNavTabs] : []),
    {
      id: 'settings-nav',
      key: navTabKeys.settings,
      title: 'Settings',
      icon: InvoiceSettingsIcon,
      path: routesPath.SETTINGS,
      clevertapEvent: clevertapEvents.WebSettingsMenu
    }
  ];
  const catalogNavTabs: NavTab[] = [
    {
      id: 'catalog-nav',
      key: navTabKeys.catalog,
      title: 'Catalog',
      icon: CatalogTabIcon,
      path: routesPath.CATALOG_ITEMS,
      clevertapEvent: clevertapEvents.webCatalogMenu,
      hasChildTabs: true,
      childTabs: [
        {
          id: 'catalog-items-nav',
          key: navTabKeys.catalogItems,
          title: 'Items',
          icon: ItemsTabReactIcon,
          path: routesPath.CATALOG_ITEMS,
          clevertapEvent: clevertapEvents.webCatalogItemsListView
        },
        {
          id: 'catalog-categories-nav',
          key: navTabKeys.catalogCategories,
          title: 'Categories',
          icon: CategoriesTabReactIcon,
          path: routesPath.CATALOG_CATEGORIES,
          clevertapEvent: clevertapEvents.webCatalogCategoryListView
        },
        {
          id: 'catalog-taxes-nav',
          key: navTabKeys.catalogTaxes,
          title: 'Taxes',
          icon: TaxesTabIcon,
          path: routesPath.CATALOG_TAXES,
          clevertapEvent: clevertapEvents.webCatalogTaxesListView
        },
        {
          id: 'catalog-service-charge-nav',
          key: navTabKeys.catalogServiceCharge,
          title: 'Service charges',
          icon: ServiceChargeTabIcon,
          path: routesPath.CATALOG_SERVICE_CHARGES,
          clevertapEvent: clevertapEvents.webCatalogServiceChargesListView
        }
      ]
    },
    ...(showBusinessLoans
      ? [
          {
            id: 'business-loans-nav',
            key: navTabKeys.businessLoans,
            title: 'Business Loans',
            icon: BusinessLoansTabIcon,
            path: routesPath.BUSINESS_LOANS,
            clevertapEvent: clevertapEvents.webBusinessLoansClick
          }
        ]
      : []),
    ...(showIntegrations
      ? [
          {
            id: 'integrations-nav',
            key: navTabKeys.integrations,
            title: 'Add ons & Integrations',
            icon: IntegrationsTabIcon,
            path: routesPath.INTEGRATIONS,
            clevertapEvent: clevertapEvents.webIntegrationsView
          }
        ]
      : [])
  ];
  return { paymentNavTabs, catalogNavTabs };
};

export const getNavSectionList = ({
  isLIP,
  isTransitionTeam,
  showIntegrations,
  showBusinessLoans,
  showEstimateSettings,
  showAccountingTab,
  showReports,
  showCapital
}: {
  isLIP: boolean;
  isTransitionTeam: boolean;
  showIntegrations: boolean;
  showBusinessLoans: boolean;
  showEstimateSettings: boolean;
  showAccountingTab: boolean;
  showReports: boolean;
  showCapital?: boolean;
}) => {
  const { paymentNavTabs, catalogNavTabs } = getPaymentsTab({
    showIntegrations,
    showBusinessLoans,
    showEstimateSettings,
    showAccountingTab,
    showReports
  });

  const baseNavWithCapital = showCapital ? [...baseNavTabs, ...capitalNavTab] : baseNavTabs;
  // const baseNavWithCapital = [...baseNavTabs];

  return isLIP || isTransitionTeam
    ? [baseNavWithCapital, paymentNavTabs, catalogNavTabs, teamNavTabs, bankingNavTabs]
    : [baseNavWithCapital, paymentNavTabs, catalogNavTabs, teamNavTabs];
};

export const navSectionList: Array<NavTab[]> = [baseNavTabs, allPaymentNavTabs, teamNavTabs, bankingNavTabs];
